import { renderNavigation } from '@vend/html-navigation'
import angular from 'angular'

import template from '../../components/register/register-actions/register-actions-popover.html'
import { EVENTS, REACT_TRAINING_MODE } from '../../constants'
import { $document, $timeout, $transitions } from '../../ng-compat/imports'
import { getFeatureFromCache } from '../../util/feature-cache'
import { openRegisterActionsPopover } from '../../state/slices/uiStateSlice'

angular
  .module('webregister.directives')
  .directive(
    'wrHtmlNavigation',
    function (
      vdPopover,
      saleSyncManager,
      saleModals,
      userManager,
      userSwitchingService,
      trainingModeManager,
      registerManager,
      webRegisterStatusManager,
      $ngRedux
    ) {
      return {
        restrict: 'E',
        link(scope, $element) {
          const toggleTutorialMode = () =>
            (trainingModeManager.tourEnabled = !trainingModeManager.tourEnabled)

          const showRegisterActions = () => {
            if (getFeatureFromCache(REACT_TRAINING_MODE)) {
              $ngRedux.dispatch(openRegisterActionsPopover())
              return
            }
            vdPopover.open({
              trigger: ($document[0] as Document).querySelector(
                '.register-info-popover-trigger'
              ),
              template,
              controller: 'RegisterActionsPopoverController',
              hasPopoverList: true,
            })
          }

          const triggerAction = () => {
            if (
              saleSyncManager.saleSyncRetryInProgress ||
              !webRegisterStatusManager.isOnline()
            ) {
              return
            }

            if (saleSyncManager.erroredSalesCount) {
              saleModals.viewErroredSales()
            } else {
              showRegisterActions()
            }
          }

          const render = () => {
            const { name: registerName } =
              registerManager.getActiveRegister() || {}
            const { name: outletName } = registerManager.getActiveOutlet() || {}

            renderNavigation(
              {
                offline: !webRegisterStatusManager.isOnline(),
                training: trainingModeManager.trainingModeEnabled,
                tutorial: trainingModeManager.tourEnabled,
                toggleTutorialMode,
                onRegisterInfoClick: () => {
                  triggerAction()
                },
                switchUser: () => {
                  $timeout(
                    userSwitchingService.selectUser.bind(userSwitchingService)
                  )
                },
                signoutUser: () => {
                  userManager.logout()
                },
                register: {
                  registerName,
                  outletName,
                  errorCount: saleSyncManager.erroredSalesCount,
                },
                currentURL: window.location.pathname,
                isError: Boolean(saleSyncManager.erroredSalesCount),
              },
              {
                user: userManager.getLoggedInUser(),
              }
            )
          }

          $timeout(render)

          $transitions.onSuccess({}, render)
          $transitions.onStart({}, transition => {
            window.dispatchEvent(
              new CustomEvent('angular-navigation-start', {
                detail: {
                  from: transition.from().url,
                  to: transition.to().url,
                },
              })
            )
          })
          trainingModeManager.on('tourEnabledChange', render)
          trainingModeManager.on('trainingModeEnabledChange', render)
          registerManager.on('activeRegisterChange', render)
          registerManager.on('activeOutletChange', render)
          userManager.on('loggedInUserChange', render)
          webRegisterStatusManager.on(EVENTS.statusChange, render)
        },
      }
    }
  )
